// source: reconpb/fractionalshare.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_type_date_pb = require('../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.reconpb.FractionalShareRecon', null, global);
goog.exportSymbol('proto.reconpb.ListFractionalShareReconRequest', null, global);
goog.exportSymbol('proto.reconpb.ListFractionalShareReconResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reconpb.FractionalShareRecon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reconpb.FractionalShareRecon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reconpb.FractionalShareRecon.displayName = 'proto.reconpb.FractionalShareRecon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reconpb.ListFractionalShareReconRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reconpb.ListFractionalShareReconRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reconpb.ListFractionalShareReconRequest.displayName = 'proto.reconpb.ListFractionalShareReconRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reconpb.ListFractionalShareReconResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reconpb.ListFractionalShareReconResponse.repeatedFields_, null);
};
goog.inherits(proto.reconpb.ListFractionalShareReconResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reconpb.ListFractionalShareReconResponse.displayName = 'proto.reconpb.ListFractionalShareReconResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reconpb.FractionalShareRecon.prototype.toObject = function(opt_includeInstance) {
  return proto.reconpb.FractionalShareRecon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reconpb.FractionalShareRecon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reconpb.FractionalShareRecon.toObject = function(includeInstance, msg) {
  var f, obj = {
systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
client: jspb.Message.getFieldWithDefault(msg, 3, ""),
fractional: jspb.Message.getFieldWithDefault(msg, 4, ""),
propTradeOwned: jspb.Message.getFieldWithDefault(msg, 5, ""),
fractionalProp: jspb.Message.getFieldWithDefault(msg, 6, ""),
propTrade: jspb.Message.getFieldWithDefault(msg, 7, ""),
customerControlMargin: jspb.Message.getFieldWithDefault(msg, 8, ""),
errorAccount: jspb.Message.getFieldWithDefault(msg, 9, ""),
tradingAccount: jspb.Message.getFieldWithDefault(msg, 10, ""),
propTradeOwnedPrice: jspb.Message.getFieldWithDefault(msg, 11, ""),
breaks: jspb.Message.getFieldWithDefault(msg, 12, ""),
date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
dateType: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reconpb.FractionalShareRecon}
 */
proto.reconpb.FractionalShareRecon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reconpb.FractionalShareRecon;
  return proto.reconpb.FractionalShareRecon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reconpb.FractionalShareRecon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reconpb.FractionalShareRecon}
 */
proto.reconpb.FractionalShareRecon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClient(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFractional(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPropTradeOwned(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFractionalProp(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPropTrade(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCustomerControlMargin(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setErrorAccount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTradingAccount(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPropTradeOwnedPrice(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBreaks(value);
      break;
    case 13:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDateType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reconpb.FractionalShareRecon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reconpb.FractionalShareRecon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reconpb.FractionalShareRecon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reconpb.FractionalShareRecon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClient();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFractional();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPropTradeOwned();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFractionalProp();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPropTrade();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCustomerControlMargin();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getErrorAccount();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTradingAccount();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPropTradeOwnedPrice();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getBreaks();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional google.type.Date system_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reconpb.FractionalShareRecon.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
*/
proto.reconpb.FractionalShareRecon.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reconpb.FractionalShareRecon.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string client = 3;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getClient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setClient = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string fractional = 4;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getFractional = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setFractional = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string prop_trade_owned = 5;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getPropTradeOwned = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setPropTradeOwned = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string fractional_prop = 6;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getFractionalProp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setFractionalProp = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string prop_trade = 7;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getPropTrade = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setPropTrade = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string customer_control_margin = 8;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getCustomerControlMargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setCustomerControlMargin = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string error_account = 9;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getErrorAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setErrorAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string trading_account = 10;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getTradingAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setTradingAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string prop_trade_owned_price = 11;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getPropTradeOwnedPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setPropTradeOwnedPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string breaks = 12;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getBreaks = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setBreaks = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.type.Date date = 13;
 * @return {?proto.google.type.Date}
 */
proto.reconpb.FractionalShareRecon.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 13));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
*/
proto.reconpb.FractionalShareRecon.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reconpb.FractionalShareRecon.prototype.hasDate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string date_type = 14;
 * @return {string}
 */
proto.reconpb.FractionalShareRecon.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.FractionalShareRecon} returns this
 */
proto.reconpb.FractionalShareRecon.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reconpb.ListFractionalShareReconRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reconpb.ListFractionalShareReconRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reconpb.ListFractionalShareReconRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
dateType: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reconpb.ListFractionalShareReconRequest}
 */
proto.reconpb.ListFractionalShareReconRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reconpb.ListFractionalShareReconRequest;
  return proto.reconpb.ListFractionalShareReconRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reconpb.ListFractionalShareReconRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reconpb.ListFractionalShareReconRequest}
 */
proto.reconpb.ListFractionalShareReconRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDateType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reconpb.ListFractionalShareReconRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reconpb.ListFractionalShareReconRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reconpb.ListFractionalShareReconRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional google.type.Date from_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reconpb.ListFractionalShareReconRequest} returns this
*/
proto.reconpb.ListFractionalShareReconRequest.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reconpb.ListFractionalShareReconRequest} returns this
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.type.Date to_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reconpb.ListFractionalShareReconRequest} returns this
*/
proto.reconpb.ListFractionalShareReconRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reconpb.ListFractionalShareReconRequest} returns this
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.ListFractionalShareReconRequest} returns this
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string date_type = 4;
 * @return {string}
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reconpb.ListFractionalShareReconRequest} returns this
 */
proto.reconpb.ListFractionalShareReconRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reconpb.ListFractionalShareReconResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reconpb.ListFractionalShareReconResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reconpb.ListFractionalShareReconResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reconpb.ListFractionalShareReconResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reconpb.ListFractionalShareReconResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
fractionalSharesList: jspb.Message.toObjectList(msg.getFractionalSharesList(),
    proto.reconpb.FractionalShareRecon.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reconpb.ListFractionalShareReconResponse}
 */
proto.reconpb.ListFractionalShareReconResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reconpb.ListFractionalShareReconResponse;
  return proto.reconpb.ListFractionalShareReconResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reconpb.ListFractionalShareReconResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reconpb.ListFractionalShareReconResponse}
 */
proto.reconpb.ListFractionalShareReconResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reconpb.FractionalShareRecon;
      reader.readMessage(value,proto.reconpb.FractionalShareRecon.deserializeBinaryFromReader);
      msg.addFractionalShares(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reconpb.ListFractionalShareReconResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reconpb.ListFractionalShareReconResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reconpb.ListFractionalShareReconResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reconpb.ListFractionalShareReconResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFractionalSharesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reconpb.FractionalShareRecon.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FractionalShareRecon fractional_shares = 1;
 * @return {!Array<!proto.reconpb.FractionalShareRecon>}
 */
proto.reconpb.ListFractionalShareReconResponse.prototype.getFractionalSharesList = function() {
  return /** @type{!Array<!proto.reconpb.FractionalShareRecon>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reconpb.FractionalShareRecon, 1));
};


/**
 * @param {!Array<!proto.reconpb.FractionalShareRecon>} value
 * @return {!proto.reconpb.ListFractionalShareReconResponse} returns this
*/
proto.reconpb.ListFractionalShareReconResponse.prototype.setFractionalSharesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reconpb.FractionalShareRecon=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reconpb.FractionalShareRecon}
 */
proto.reconpb.ListFractionalShareReconResponse.prototype.addFractionalShares = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reconpb.FractionalShareRecon, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reconpb.ListFractionalShareReconResponse} returns this
 */
proto.reconpb.ListFractionalShareReconResponse.prototype.clearFractionalSharesList = function() {
  return this.setFractionalSharesList([]);
};


goog.object.extend(exports, proto.reconpb);
